require('./brokerInformationAboutProduct.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { formatText } = require('core/i18n').i18n;


// @commons
const ProductBanner = require('components/commons/productBanner/productBanner');

// @helpers
const { getPublicSitePathByLanguaje } = require('core/apiURLBuilder');

// @constants
const WEALTH_PRODUCT_BANNERS = require ('constants/productBanners/wealthProductBanners');
const {
    TYPE_STOCKS,
    TYPE_ETFS,
    TYPE_WARRANTS,
    TYPE_FUNDS,
    TYPE_FUTURES,
    TYPE_PLANS,
    TYPE_CM,
    ALTERNATIVE_FUNDS,
} = require('constants/index');

class BrokerInformationAboutProduct extends React.Component {
    constructor(props){
        super(props);
        this.prepareDescription = this.prepareDescription.bind(this);
    }

    prepareDescription(isCollective, productType) {
        const {
            immCollectivesCommissions,
        } = this.props;
        const {
            advantages,
            advantagesCollectivo
        } = WEALTH_PRODUCT_BANNERS[productType];

        let descriptionKey, titleKey;
        if (isCollective) {
            titleKey = immCollectivesCommissions.get('titleKey');
            descriptionKey = immCollectivesCommissions.get('descriptionKey');
        }
        let content = isCollective && advantagesCollectivo ? advantagesCollectivo : advantages;

        return content.map(function(advantage,index){
            if (((index == 3 && productType == TYPE_ETFS) || (index == 0 && productType == TYPE_STOCKS)) && isCollective) {
                return {
                    text: titleKey,
                    icon: advantage.icon,
                    description: descriptionKey
                }
            } else {
                return advantage;
            }
        })
    }

    render() {
        const {
            externalLink,
            immCollectivesCommissions,
            productType,
            hasButton,
            immGlobalVariables,
            onFooterLinkClick
        } = this.props;

        let buyButtonLabel, isCollective, url;
        if (this.props.immProfile) {
            isCollective = this.props.immProfile.get('isCollective');
        }
        if (isCollective) {
            url = immCollectivesCommissions.get('url');
        }

        if (productType !== TYPE_FUTURES) {
            buyButtonLabel = "informationAboutProduct-buyLabel";
        }

        let moreInfoURL;
        let hasComplementaryLink = true;
        let complementaryLinkText = 'corporatesOperations-moreInformation'

        let hasSecondaryLink = false;
        let secondaryLinkLabel = null;
        let secondaryLinkURL = null;

        switch (productType) {
            case TYPE_FUNDS:
                moreInfoURL = formatText('corporatesOperations-fundsLandingLinkURL');
                break;
            case TYPE_ETFS:
                if (isCollective) {
                    moreInfoURL = url;
                } else {
                    moreInfoURL = formatText('corporatesOperations-ETFsLandingLinkURL');
                }
                hasSecondaryLink = true;
                secondaryLinkLabel = 'corporatesOperations-ETFsLandingSecondaryLinkLabel'
                secondaryLinkURL = formatText('corporatesOperations-ETFsLandingSecondaryLinkURL');
                break;
            case TYPE_WARRANTS:
                moreInfoURL = formatText('corporatesOperations-warrantsLandingLinkURL');
                break;
            case TYPE_PLANS:
                moreInfoURL = formatText('brokerURL-brokerURL_pensionPlanLandingMoreInformation');
                complementaryLinkText = 'corporatesOperations-pensionPlanLandingComplementaryLinkText'
                hasSecondaryLink = true;
                secondaryLinkLabel = 'corporatesOperations-pensionPlanLandingSecondaryLinkText'
                secondaryLinkURL = formatText('corporatesOperations-pensionPlanLandingSecondaryLinkURL');
                break;
            case TYPE_CM:
                buyButtonLabel ="informationAboutProduct-buyLabelCM";
                moreInfoURL = getPublicSitePathByLanguaje('brokerURL-brokerURL_GDI');
                hasComplementaryLink = false;
                break;
            case ALTERNATIVE_FUNDS:
                hasComplementaryLink = true;
                complementaryLinkText = 'brokerAlternativeFunds-productBanner_footerLink'
                break;
            default:
                if (isCollective) {
                    moreInfoURL = url;
                } else {
                    moreInfoURL = immGlobalVariables.getIn(['variables', 'parameters', 'contratos', 'compra_acciones']);
                }
        }

        const advantagesWealth = this.prepareDescription(isCollective, productType);
        const {
            id,
            title,
            sidebarImgUrl
        } = WEALTH_PRODUCT_BANNERS[productType];
        const showButton = (!__CONTACT_CENTER__ || !externalLink) && productType !== TYPE_CM ? hasButton : false;

        return (
            <ProductBanner
                advantages={advantagesWealth}
                onFooterLinkClick={onFooterLinkClick}
                complementaryLink={moreInfoURL}
                complementaryLinkText={complementaryLinkText}
                hasComplementaryLink={hasComplementaryLink}
                hasSidebarImg={!!sidebarImgUrl}
                sidebarImgUrl={sidebarImgUrl}
                id={id}
                isCollectiveUser={isCollective}
                key={`wealth-product-banners-${productType}`}
                linkText={buyButtonLabel}
                onButtonClickHandle={this.props.onBuyClick}
                productModifier="wealth"
                title={title}
                hasButton={showButton}
                hasSecondaryLink={hasSecondaryLink}
                secondaryLinkLabel={secondaryLinkLabel}
                secondaryLinkURL={secondaryLinkURL}
                pageName={this.props.pageName}
            />
        );
    }
}

BrokerInformationAboutProduct.propTypes = {
    externalLink: PropTypes.bool,
    immProfile: PropTypes.object,
    immGlobalVariables: PropTypes.object,
    immCollectivesCommissions: PropTypes.object,
    onBuyClick: PropTypes.func,
    onFooterLinkClick: PropTypes.func,
    productType: PropTypes.oneOf([
        TYPE_STOCKS,
        TYPE_ETFS,
        TYPE_WARRANTS,
        TYPE_FUNDS,
        TYPE_PLANS
    ]).isRequired,
    hasButton: PropTypes.bool,
    pageName: PropTypes.string
};

BrokerInformationAboutProduct.defaultProps = {
    externalLink: false,
    hasButton: true,
    pageName: '',
    onFooterLinkClick: null
}

module.exports = BrokerInformationAboutProduct;

